import { usePathname } from 'next/navigation';

import { SPORTS_ROUTES } from './helpers';

export const useIsSports = () => {
  const pathname = usePathname();

  const isSports = pathname.includes(SPORTS_ROUTES);

  return isSports;
};
